export interface NavLink {
  id: string;
  label: string;
}

export const navLinks: NavLink[] = [
  { id: "intro", label: "影片简介" },
  { id: "plot", label: "剧情脉络" },
  { id: "cast", label: "主要人物" },
  { id: "commentary", label: "深度解说" },
  { id: "reviews", label: "影评观点" },
  { id: "clips", label: "经典片段" },
  { id: "bloopers", label: "幕后花絮" },
  { id: "eggs", label: "彩蛋细节" },
  { id: "faq", label: "观影问答" },
];

export interface AboutItem {
  icon: string;
  title: string;
  desc: string;
  anchor: string;
}

export const aboutItems: AboutItem[] = [
  {
    icon: "ri-book-open-line",
    title: "剧情脉络",
    desc: "按时间顺序梳理主角向西从少年启蒙、留学英伦到北上旅程的完整故事线，先看懂人，再看懂故事。",
    anchor: "plot",
  },
  {
    icon: "ri-movie-2-line",
    title: "深度解说",
    desc: "从主题、人物弧光与时代背景三个角度逐层拆解，说明这部喜剧外壳下真正在讲什么。",
    anchor: "commentary",
  },
  {
    icon: "ri-quill-pen-line",
    title: "影评观点",
    desc: "整理不同立场的观影评价，既有认可的亮点，也有争议与批评，帮助你形成自己的判断。",
    anchor: "reviews",
  },
  {
    icon: "ri-film-line",
    title: "经典片段",
    desc: "按主题标签归纳片中有代表性的桥段，说明每个片段在故事里的位置与作用，方便按兴趣查阅。",
    anchor: "clips",
  },
  {
    icon: "ri-clapperboard-line",
    title: "幕后花絮",
    desc: "原著改编、导演身兼主演、取景与拍摄节奏等制作层面的细节，了解成片之外的工序。",
    anchor: "bloopers",
  },
  {
    icon: "ri-magic-line",
    title: "彩蛋细节",
    desc: "容易被忽略的呼应、道具与台词伏笔，二刷时可以作为额外的观察线索。",
    anchor: "eggs",
  },
];

export interface FilmFact {
  label: string;
  value: string;
}

export const filmFacts: FilmFact[] = [
  { label: "片名", value: "一路向西" },
  { label: "英文名", value: "Due West: Our Sex Journey" },
  { label: "导演 / 编剧", value: "胡耀辉" },
  { label: "上映时间", value: "2012 年 9 月 20 日（香港）" },
  { label: "片长", value: "约 118 分钟" },
  { label: "类型", value: "喜剧 · 爱情 · 剧情" },
  { label: "原著", value: "向西村上春树《东莞的森林》" },
  { label: "语言", value: "粤语、普通话" },
];

export interface PlotStage {
  order: string;
  title: string;
  period: string;
  desc: string;
}

export const plotStages: PlotStage[] = [
  {
    order: "01",
    title: "少年启蒙",
    period: "香港 · 成长时期",
    desc: "故事从主角向西在香港的成长讲起。少年时期的懵懂、同学间的玩笑与家庭里的沉默，共同构成了他对两性关系最初也最混乱的认知。这一段奠定了全片自传式的口吻，也让后来的种种选择有了来处。",
  },
  {
    order: "02",
    title: "留学英伦",
    period: "英国 · 求学时期",
    desc: "远赴英国读书后，向西第一次直接面对与自己成长环境截然不同的观念。开放的社交氛围、语言与文化的隔阂，让他在新鲜与无所适从中反复摇摆，也迫使他重新思考自己想要的到底是什么。",
  },
  {
    order: "03",
    title: "情感波折",
    period: "交往与分离",
    desc: "在异乡的一段感情里，向西经历了从靠近到疏远的完整过程。观念差异与沟通不畅最终让两人分开，这段挫败成为他心态转变的关键节点，也埋下了此后一系列冲动的伏笔。",
  },
  {
    order: "04",
    title: "北上启程",
    period: "好友影响 · 出发",
    desc: "回到熟悉的圈子里，向西在好友王静、占士等人的影响与带动下，踏上俗称“北上”的旅程。外表是一次放松的出游，内里却是一个年轻人试图用外在刺激填补内在空洞的开始。",
  },
  {
    order: "05",
    title: "见闻百态",
    period: "一路向西 · 途中",
    desc: "旅途中的见闻鱼龙混杂，热闹与荒唐并存。向西见识了形形色色的人和事，在一次次似真似假的相遇里逐渐发现，欲望被满足之后，随之而来的是更深的空虚与疑问。",
  },
  {
    order: "06",
    title: "回归与反思",
    period: "终点 · 回望",
    desc: "旅途走到尽头，故事并没有给出简单的答案。向西回望整段经历，重新审视“性与爱”“情与欲”的边界。影片用开放式的收束，把成长的困惑留给观众自己去完成。",
  },
];

export interface HintItem {
  icon: string;
  title: string;
  desc: string;
}

export const viewingHints: HintItem[] = [
  {
    icon: "ri-shield-star-line",
    title: "分级提示",
    desc: "本片在香港属三级片，含成人题材与相关表达，未满十八岁请勿观看，也不适合未成年人陪同观看。",
  },
  {
    icon: "ri-user-heart-line",
    title: "观看建议",
    desc: "建议把它当作一部带有黑色幽默的成长剧情片来理解，关注人物的心态变化，而不只停留在表层噱头。",
  },
  {
    icon: "ri-lightbulb-line",
    title: "阅读顺序",
    desc: "先读剧情脉络建立时间线，再看解说与影评，最后用片段和彩蛋回看细节，理解会更完整。",
  },
];